import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'


// 引入全局css样式
import "assets/css/base.css";
import "assets/css/index.css";

// 引入 element-ui,闭包执行
import '@/plugins/element-ui.js'

import ElementUI from 'element-ui';
ElementUI.Dialog.props.closeOnClickModal.default = false

/* import VideoPlayer from 'vue-video-player'
Vue.use(VideoPlayer)
require('vue-video-player/src/custom-theme.css') */
/* import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

Vue.use(VideoPlayer) */

import { message } from './utils/resetMessage'
Vue.use(ElementUI)
Vue.prototype.$message = message;


// import Antd from 'ant-design-vue'
// import 'ant-design-vue/dist/antd.css'
// Vue.use(Antd)



/* import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video */

Vue.config.productionTip = false

// 设置开发状态，使用mock模拟后端数据
// if (process.env.NODE_ENV === 'development') require('api/mock')

new Vue({
  router,
  store,
  data: function(){
          // 全局变量
          // 调用 this.$root.isActiveApp
          // 赋值 this.$root.colorController = !this.$root.colorController
          return {
              isActiveApp: true,
              //colorController: 'black',
              colorController: '#000',
              closeTages: true,
          }
      },
  render: h => h(App)
}).$mount('#app')

// 禁止输入特殊字符
Vue.prototype.validForbid = function (value, number = 255) {
  value = value.replace(/[`~!@#$%^&*()_\-+=<>?:"{}|,./;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/g, '').replace(/\s/g, "");
  if (value.length >= number) {
    this.$message({
      type: "warning",
      message: `输入内容不能超过${number}个字符`
    });
  }
  return value;
}

import BaiduMap from "vue-baidu-map"
Vue.use(BaiduMap,{
    // ak:'c285EvoFwodyUsTDY4sGiGV1',
	ak:'2KDU3gQN5vTQGhVsEmMdyiYkxuQUWdVN'
})
